<template>
  <div class="checkbox-filters">
    <filter-card-wrapper
      :title="title"
      :expanded="expanded"
    >
      <div
        v-if="options.length > 5"
        slot="header"
        class="checkbox-filters__header"
      >
        <TextInput
          placeholder="Type your search term..."
          :value="query"
          :show-close="true"
          @onChange="onSearch"
          @onClear="query = ''"
        />
      </div>
      <div
        v-if="computedOptions.length"
        slot="body"
        class="checkbox-filters__body"
        :class="{ scroll: computedOptions.length > 5 }"
      >
        <checkbox
          v-for="(option, key) in computedOptions"
          :id="key"
          :key="key"
          :label="option.value"
          :value="option.value"
          :count="option.count"
          :checked="values.indexOf(option.value) > -1"
          @onchange="onCheckboxChange($event, option.value, title)"
        />
      </div>
      <div
        v-else
        slot="body"
        class="checkbox-filters__body"
        :class="{ scroll: computedOptions.length > 5 }"
      >
        <div class="checkbox-filters__body--rich-text">
          <p>No result found</p>
        </div>
      </div>
      <div
        slot="footer"
        class="checkbox-filters__footer"
      >
        <div class="checkbox-filters__footer__count-selection-area">
          <div
            v-if="options.length"
            class="checkbox-filters__footer__count-selection-area--count-section"
          >
            {{
              values.length
                ? `Including ${values.length} of ${options.length}`
                : `Including all ${options.length}`
            }}
          </div>
          <div
            v-if="options.length === values.length"
            class="checkbox-filters__footer__count-selection-area--select-all"
            @click="onCheckboxMultiSelect('selectNone', title)"
          >
            <span>
              Select none
            </span>
          </div>
          <div
            v-else
            class="checkbox-filters__footer__count-selection-area--select-all"
            @click="onCheckboxMultiSelect('selectAll', title)"
          >
            <span>
              Select all
            </span>
          </div>
        </div>
        <!-- <div class="checkbox-filters__footer__show-area">
          <span>
            Show more
          </span>
        </div> -->
      </div>
    </filter-card-wrapper>
  </div>
</template>

<script>
// Common components
import { Checkbox, TextInput } from "../../components";
// Filter dependent component
import FilterCardWrapper from "./FilterCardWrapper";

export default {
  name: "CheckboxFilter",
  components: {
    FilterCardWrapper,
    Checkbox,
    TextInput,
  },
  props: {
    /**
     * @description
     * Name of the filter
    */
    title: { type: String, required: true },
    /**
     * @description
     * When expaneded flag is true, filter content will be shown
    */
    expanded: { type: Boolean, default: false },
    /**
     * @description
     * List of filter options
    */
    options: { type: Array, required: true },
    /**
     * @description
     * List of selected values for each filter option
    */
    values: { type: Array, required: false, default: () => { } },
    /**
     * @description
     * fitelData holds complete Object of this filter and it will be returned along with checkbox on change callback
    */
    fieldData: { type: Object, required: true },
  },
  data () {
    return {
      query: "",
    };
  },
  computed: {
    /**
     * @description
     * computedOptions returns list of filtered options based on the given search query
     * @returns {array} - List of filtered options
    */
    computedOptions () {
      return this.query
        ? this.options.filter((option) => {
          return option.value
            ?.toString()
            .toLowerCase()
            .match(this.query.toLowerCase());
        })
        : this.options;
    },
  },
  methods: {
    /**
     * @description
     * Triggered on toggle of a single checkbox,
     * Calls onCheckboxSelect listener method defined on the parent(FilterBar) component,
     * Calls setFilterModified method defined on the parent(FilterBar) component
     * @param {boolean} isChecked - Status of checkbox
     * @param {string} selectedValue - Selected value of checkbox
     * @param {string} selectedKey - Name of the filter card
    */
    onCheckboxChange (isChecked, selectedValue, selectedKey) {
      this.$parent.$listeners.onCheckboxSelect(
        isChecked,
        selectedValue,
        selectedKey,
        this.fieldData
      );
      this.$parent.setFilterModified(true);
    },
    /**
     * @description
     * Triggered on toggle of a multi-select checkbox,
     * Calls onCheckboxMultiSelect listener method defined on the parent(FilterBar) component,
     * Calls setFilterModified method defined on the parent(FilterBar) component
     * @param {string} selectionType - Selection type will be either "Select all" (or) "Select none"
     * @param {strng} selectedKey - Name of the filter card
    */
    onCheckboxMultiSelect (selectionType, selectedKey) {
      this.$parent.$listeners.onCheckboxMultiSelect(
        selectionType,
        selectedKey,
        this.fieldData
      );
      this.$parent.setFilterModified(true);
    },
     /**
     * @description
     * Sets the search term value
     * @param {object} e - event object
    */
    onSearch (e) {
      this.query = e.target.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox-filters {
  display: flex;
  & .checkbox-filters__header {
    margin-top: 16px;
  }
  & .checkbox-filters__body {
    margin-top: 16px;
    &.scroll {
      max-height: 200px;
      overflow-y: auto;
    }
  }
  & .checkbox-filters__footer {
    display: flex;
    flex-direction: column;
    & .checkbox-filters__footer__count-selection-area {
      justify-content: space-between;
      display: flex;
      margin-top: 12px;
      flex: 1;
      & .checkbox-filters__footer__count-selection-area--count-section {
        font-family: "Maersk Text";
        font-size: 14px;
        line-height: 16px;
        color: var(--Gray-600);
      }
      & .checkbox-filters__footer__count-selection-area--select-all {
        font-family: "Maersk Text";
        font-size: 14px;
        line-height: 16px;
        color: var(--Blue-600-Dark);
        cursor: pointer;
        text-decoration: underline;
      }
    }
    & .checkbox-filters__footer__show-area {
      display: flex;
      justify-content: center;
      & span {
        margin-top: 12px;
        font-family: "Maersk Text";
        font-size: 14px;
        line-height: 16px;
        color: var(--Blue-600-Dark);
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}
</style>
